import React from 'react';

import AllRoutes from "./routes/Routes.jsx";
import { MenuProvider } from "./hooks/useMenuPermissions.jsx";
import { ProfileProvider } from "@/context";

// import { configureFakeBackend } from './helpers';

import "nouislider/distribute/nouislider.css";

import "./assets/scss/app.scss";
import "./assets/scss/icons.scss";

// configure fake backend - DISABLED for real API
// configureFakeBackend()

const App = () => {

  return (
    <>
      <React.Fragment>
        <ProfileProvider>
          <MenuProvider>
            <AllRoutes />
          </MenuProvider>
        </ProfileProvider>
      </React.Fragment>
    </>
  );
}

export default App;
